import { create } from 'zustand';

/**
 * Tracks whether a new app build has been downloaded and is waiting to
 * activate. The service worker registration (utils/pwa.ts) flips this on when
 * a new version is installed; the UpdatePrompt component decides whether to
 * apply it silently (safe screens) or defer behind a prompt (mid-inspection).
 */
interface PwaUpdateState {
  /** A new build is installed and waiting to take over. */
  updateReady: boolean;
  setUpdateReady: (v: boolean) => void;
}

export const usePwaUpdateStore = create<PwaUpdateState>((set) => ({
  updateReady: false,
  setUpdateReady: (updateReady) => set({ updateReady }),
}));
